module.exports = __webpack_public_path__ + "static/media/ws04.7b98ab7d.webp";